import { FC } from 'react'
import { useForm, FormProvider, FormProviderProps, useFormContext } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import {
  ConfigurableBuilderSchema,
  IConfigurableBuilderSchema,
} from '../schema/ConfigurableBuilderSchema'

export const useConfigurableBuilderForm = () => {
  return useForm<IConfigurableBuilderSchema>({
    resolver: yupResolver(ConfigurableBuilderSchema),
    mode: 'onChange',
  })
}

export const ConfigurableBuilderFormProvider: FC<FormProviderProps<
  IConfigurableBuilderSchema
>> = FormProvider

export const useConfigurableBuilderFormContext = () => useFormContext<IConfigurableBuilderSchema>()
